"use client"
import { CardEspecifications } from "./CardEspecifications";
import Image from "next/image";
import { manrope, ubuntu } from "@/ui/fonts";
import TooltipEspecificaciones from "../especificaciones-component/TooltipEspecificaciones";
import { useEffect, useState } from "react";
import { SliderEbikeMincaCity, getBanner } from "@/lib/graphQLRequest";
import Link from "next/link";
import TooltipEspecificacionesLite from "../especificaciones-component/ToolTipLite";
import { SkeletonCarrusel } from "./SkeletonCarrusel";
import TooltipCity from "../especificaciones-component/ToolTipCity";

export const City = () => {
  const [selectedColor, setSelectedColor] = useState("red");
  const [mincaCity, setMincaCity] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await SliderEbikeMincaCity();
      setMincaCity(data);
    };

    fetchData();
  }, []);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
  };

  // If mincaCity is still null, you can render a loading state or return null
  if (!mincaCity) {
    return <SkeletonCarrusel />;
  }

  const firstPartTitle = (title) => {
    let ArrayTtile = title.split(" ")
    return ArrayTtile[0] + " " + ArrayTtile[1]
  }

  const SecondPartPartTitle = (title) => {
    let ArrayTtile = title.split(" ")
    return ArrayTtile[2] + " " + ArrayTtile[3] + " " + ArrayTtile[4]
  }

  return (
    <>
      <div className="heroImagen relative lg:mt-4">
        <div className="mt-4">

          {/* PC */}
          <video
            className="top-0 hidden h-[663px] w-full object-cover  lg:block"
            src={`https://test.mincaelectric.com/wp-content/uploads/2024/08/Minca-City-Horizontal-Minca-Electric-720.mp4`}
            autoPlay
            muted
            loop
          />

          {/* Movil */}
          <video
            className="top-0 h-[400px] w-full object-cover lg:hidden"
            src="https://test.mincaelectric.com/wp-content/uploads/2024/08/Minca-City-Horizontal-Minca-Electric-720.mp4"
            autoPlay
            muted
            loop
            playsInline
            preload="none"
            poster="https://test.mincaelectric.com/wp-content/uploads/2025/04/Es-posible-recorrer-toda-la-ciudad-con-una-patineta-electrica-Lo-que-debes-saber-sobre-autonomia-y-rutas-sostenibles.jpg"
          />

          <div className="overlay absolute top-0 flex h-[400px] w-full flex-col items-start justify-center bg-[#111]/50 p-4 lg:h-[663px] lg:px-[100px]">
            <div className="lg:flex lg:w-full lg:justify-between">
              <div className={`grid text-[50px] text-white lg:text-[64px]`}>
                <div className="flex flex-col items-start justify-center">
                  <span className="font-light">MINCA</span>
                  <span className="hidden lg:flex font-bold -mt-8">Mopeds Eléctricas</span>
                  <span className="lg:hidden font-bold -mt-6">Mopeds</span>
                  <span className="lg:hidden font-bold -mt-6">Eléctricas</span>
                </div>
              </div>
              <div>
                <Image
                  placeholder="empty"
                  alt="publicidad"
                  className="logo-minca-m hidden shadow-none lg:block"
                  src="/Logo-lineas-Minca-Electric.png"
                  width={390}
                  height={400}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="carrusel h-auto w-full ">
        <div id="city" className="relative p-4 lg:px-[100px] lg:py-14">
          <div className="slogan-dots mb-4 flex items-center justify-between">
            <div>
              <p className={`${ubuntu.className} text-[14px] text-[#42454A] `}>
              {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.slogan}
              </p>
            </div>
          </div>
          <Image
            placeholder="empty"
            alt={`Minca city ${selectedColor}`}
            className="lg:hidden mb-4"
            src={
              selectedColor === "red"
                ? mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.foto1.mediaItemUrl
                : mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.foto2.mediaItemUrl
            }
            priority={true}
            width={390}
            height={400}
            style={{ objectFit: "cover" }}
          />

          <div className="flex items-center justify-between bg-white pl-1 pr-4 lg:hidden">
            <div className="w-100 flex items-center">
              <svg
                xmlns="https://www.w3.org/2000/svg"
                width={123}
                height={52}
                viewBox="0 0 123 52"
                fill="none"
              >
                <g clipPath="url(#a)">
                  <path
                    fill="#111110"
                    d="M70.903 49.122a2.747 2.747 0 0 0 2.75 2.75h29.446a2.744 2.744 0 0 0 2.529-1.666l16.477-38.443c.775-1.815-.555-3.833-2.529-3.833H91.865c-1.965 0-3.295-2-2.538-3.815l.133-.309c.757-1.815-.573-3.815-2.538-3.815H48.25c-.731 0-1.428.291-1.947.81L41.73 5.376c-.52.52-1.216.81-1.948.81H18.17c-1.084 0-2.071.644-2.52 1.64L.238 42.504c-.81 1.824.52 3.868 2.52 3.868h65.396a2.747 2.747 0 0 1 2.75 2.75Z"
                  />
                  <g fill="#fff">
                    <path d="M17.261 38.064c-5.965 0-7.754-2.996-5.384-8.987l3.437-8.397c.722-1.806 1.436-3.287 2.159-4.45.722-1.163 1.56-2.08 2.51-2.758.944-.67 2.054-1.136 3.314-1.4 1.268-.256 2.802-.388 4.608-.388h16.124l-3.348 8.309H29.35c-.538 0-.934.088-1.18.273-.239.176-.468.528-.67 1.04l-2.89 7.136c-.362.873-.106 1.313.766 1.313h11.34l-3.348 8.31H17.243h.018ZM48.065 11.683h12.468L49.87 38.064H37.403l10.662-26.38Zm3.348-8.308h12.459l-2.44 6.097h-12.46l2.441-6.097ZM63.378 11.683h2.485l2.124-5.242 13.181-1.807-2.846 7.05h5.683l-3.34 8.308h-5.691l-3.428 8.45c-.361.872-.105 1.313.767 1.313h6.326l-3.34 8.309H64.19c-5.965 0-7.754-2.996-5.375-8.988l3.71-9.084h-2.485l3.348-8.309h-.009ZM82.164 38.064h9.578c.51 0 .89-.088 1.128-.273.246-.185.484-.529.722-1.04l.317-.81h-6.731c-5.965 0-7.754-2.996-5.375-8.988l6.185-15.27h12.468L94.535 26.32c-.361.872-.106 1.313.767 1.313h.634c.511 0 .899-.088 1.145-.273.256-.185.494-.53.705-1.04l5.913-14.635h12.467l-10.388 25.693c-.714 1.806-1.454 3.286-2.185 4.458-.731 1.155-1.577 2.08-2.529 2.75-.952.678-2.053 1.145-3.322 1.4-1.26.256-2.784.38-4.555.38H78.825l3.34-8.31v.01Z" />
                  </g>
                </g>
                <defs>
                  <clipPath id="a">
                    <path fill="#fff" d="M0 0h122.334v51.88H0z" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div className="flex items-center justify-end lg:hidden">
              <div className="text-center">
                <p className="mb-2 text-[14px]">Selecciona el color</p>
                <div className="mb-4 flex justify-center space-x-4">
                  <div className="flex h-8 w-8 items-center justify-center">
                    <div
                      className={`rounded-full border-4 ${
                        selectedColor === "red"
                          ? "h-8 w-8 border-white"
                          : "h-6 w-6 border-transparent"
                      } bg-red-500 shadow-lg`}
                      onClick={() => handleColorSelect("red")}
                      style={{
                        cursor: "pointer",
                        boxShadow: "0 3px 4px rgba(0, 0, 0, 0.5)",
                      }}
                    ></div>
                  </div>
                  <div className="flex h-8 w-8 items-center justify-center">
                    <div
                      className={`rounded-full border-4 ${
                        selectedColor === "gray"
                          ? "h-8 w-8 border-white"
                          : "h-6 w-6 border-transparent"
                      } bg-gray-500 shadow-lg`}
                      onClick={() => handleColorSelect("gray")}
                      style={{
                        cursor: "pointer",
                        boxShadow: "0 3px 4px rgba(0, 0, 0, 0.5)",
                      }}
                    ></div>
                  </div>
                </div>
                <p className="text-[12px] font-bold">
                  {selectedColor === "red"
                    ? "NEGRO MATE - ROJO"
                    : "NEGRO MATE - GRIS"}
                </p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex justify-between">
              <div className="-z-5 mt-10 flex flex-col justify-center">
                <h2
                  className={`${manrope.className} mb-1 text-[20px] font-bold uppercase text-[#111111]  lg:text-[42px] lg:leading-[45px]`}
                >
                  MOPED ELÉCTRICA <br/>
                  {SecondPartPartTitle(mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.nombreProducto)}
                </h2>
                <p
                    className={`${manrope.className} mb-1 text-[16px] font-normal uppercase text-[#111111]  lg:mt-4 lg:text-[26px] lg:font-medium`}
                  >
                    {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.subtitulo}
                  </p>
                <p
                  className={`${ubuntu.className} text-[16px] font-normal leading-[15px] text-[#42454A]  lg:mt-5 lg:w-[370px] lg:text-[16px] lg:leading-[25px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.description}
                </p>
                
                <div className="my-6 flex items-center gap-3 lg:mt-2 lg:gap-4">
                <div
                  className={`${manrope.className} text-[18px] font-bold text-[#111111]  opacity-50 lg:text-[26px]`}
                >
                  <p className="text-[14px]">Antes</p>
                  <del>{"$" + mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.precioRebajado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</del>
                </div>
                <div
                  className={`${manrope.className} text-[18px] font-bold text-[#111111]  lg:text-[26px]`}
                >
                  <p className="text-[14px]">Ahora</p>
                  {"$" + mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.precioActual.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                </div>
                {/* <div className="mt-4">
                  <TooltipCity />
                </div> */}
                <span className="items-center justify-center rounded-full bg-green-500 bg-opacity-10 px-2.5 py-0.5 text-green-800 lg:inline-flex lg:h-8 lg:px-[14px] lg:py-[6px]">
                  <p
                    className={`${manrope.className} whitespace-nowrap text-sm  `}
                  >
                    {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.descuento}%
                  </p>
                </span>
              </div>

                <addi-widget price={Number(mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.precioActual)} ally-slug="mincaelectric-ecommerce"></addi-widget>

                <div className="hidden lg:block lg:mb-[30px] 2xl:mb-[35px] 2xl:mt-[30px]">
                  <svg
                    xmlns="https://www.w3.org/2000/svg"
                    width={123}
                    height={52}
                    fill="none"
                  >
                    <g clipPath="url(#a)">
                      <path
                        fill="#111110"
                        d="M70.903 49.122a2.747 2.747 0 0 0 2.75 2.75h29.446a2.744 2.744 0 0 0 2.529-1.666l16.477-38.443c.775-1.815-.555-3.833-2.529-3.833H91.865c-1.965 0-3.295-2-2.538-3.815l.133-.309c.757-1.815-.573-3.815-2.538-3.815H48.25c-.731 0-1.428.291-1.947.81L41.73 5.376c-.52.52-1.216.81-1.948.81H18.17c-1.084 0-2.071.644-2.52 1.64L.238 42.504c-.81 1.824.52 3.868 2.52 3.868h65.396a2.747 2.747 0 0 1 2.75 2.75Z"
                      />
                      <g fill="#fff">
                        <path d="M17.261 38.064c-5.965 0-7.754-2.996-5.384-8.987l3.437-8.397c.722-1.806 1.436-3.287 2.159-4.45.722-1.163 1.56-2.08 2.51-2.758.944-.67 2.054-1.136 3.314-1.4 1.268-.256 2.802-.388 4.608-.388h16.124l-3.348 8.309H29.35c-.538 0-.934.088-1.18.273-.239.176-.468.528-.67 1.04l-2.89 7.136c-.362.873-.106 1.313.766 1.313h11.34l-3.348 8.31H17.243h.018ZM48.065 11.683h12.468L49.87 38.064H37.403l10.662-26.38Zm3.348-8.308h12.459l-2.44 6.097h-12.46l2.441-6.097ZM63.378 11.683h2.485l2.124-5.242 13.181-1.807-2.846 7.05h5.683l-3.34 8.308h-5.691l-3.428 8.45c-.361.872-.105 1.313.767 1.313h6.326l-3.34 8.309H64.19c-5.965 0-7.754-2.996-5.375-8.988l3.71-9.084h-2.485l3.348-8.309h-.009ZM82.164 38.064h9.578c.51 0 .89-.088 1.128-.273.246-.185.484-.529.722-1.04l.317-.81h-6.731c-5.965 0-7.754-2.996-5.375-8.988l6.185-15.27h12.468L94.535 26.32c-.361.872-.106 1.313.767 1.313h.634c.511 0 .899-.088 1.145-.273.256-.185.494-.53.705-1.04l5.913-14.635h12.467l-10.388 25.693c-.714 1.806-1.454 3.286-2.185 4.458-.731 1.155-1.577 2.08-2.529 2.75-.952.678-2.053 1.145-3.322 1.4-1.26.256-2.784.38-4.555.38H78.825l3.34-8.31v.01Z" />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#fff" d="M0 0h122.334v51.88H0z" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className={`${manrope.className} text-[10px]`}>
                  *El vehículo Minca City requiere matrícula, SOAT vigente y <br/>
                  licencia de conducción para circular legalmente en vías públicas.
                </p>
              </div>
              <Image
                placeholder="empty"
                alt={`Minca city ${selectedColor}`}
                className="hidden lg:block lg:w-[530px] lg:h-[422px] 2xl:w-[750px] 2xl:h-[565px] 2xl:mr-[100px] lg:-ml-[21px] 2xl:ml-[100px] 2xl:mb-14"
                src={
                  selectedColor === "red"
                  ? mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.foto1.mediaItemUrl
                  : mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.foto2.mediaItemUrl
                }
                width={650}
                height={450}
              />

              <div className="lg:mt-40 2xl:mt-60 hidden lg:block lg:ml-[20px] 2xl:ml-[150px] -z-5">
                <div className="flex items-center justify-end ">
                  <div className="mt-10 text-center">
                    <p className="mb-4 text-[14px]">Selecciona el color</p>
                    <div className="mb-4 flex justify-center space-x-4">
                      <div className="flex h-8 w-8 items-center justify-center">
                        <div
                          className={`rounded-full border-4 ${
                            selectedColor === "red"
                              ? "h-8 w-8 border-white"
                              : "h-6 w-6 border-transparent"
                          } bg-red-500 shadow-lg`}
                          onClick={() => handleColorSelect("red")}
                          style={{
                            cursor: "pointer",
                            boxShadow: "0 3px 4px rgba(0, 0, 0, 0.5)",
                          }}
                        ></div>
                      </div>
                      <div className="flex h-8 w-8 items-center justify-center">
                        <div
                          className={`rounded-full border-4 ${
                            selectedColor === "gray"
                              ? "h-8 w-8 border-white"
                              : "h-6 w-6 border-transparent"
                          } bg-gray-500 shadow-lg`}
                          onClick={() => handleColorSelect("gray")}
                          style={{
                            cursor: "pointer",
                            boxShadow: "0 3px 4px rgba(0, 0, 0, 0.5)",
                          }}
                        ></div>
                      </div>
                    </div>
                    <p className="text-[12px] font-bold">
                      {selectedColor === "red"
                        ? "NEGRO MATE - ROJO"
                        : "NEGRO MATE - GRIS"}
                    </p>
                  </div>
                </div>
                  <Link
                    href={`/productos/Mopeds_Electricas/MOPED_ELCTRICA_MINCA_CITY_350W`}
                    className="btn-scooter gird z-10 my-3 flex h-[40px] w-full place-items-center justify-center rounded-[62px]  bg-[#111] text-[16px] text-white lg:absolute lg:right-[100px]  lg:top-[59.2%]  lg:h-[48px] lg:w-[195px] 2xl:w-[235px] 2xl:mr-[2px] mt-5">
                  Comprar Ahora
                </Link>
              </div>

              <div className="hidden flex-col justify-center lg:invisible lg:flex"></div>
            </div>
          </div>
          {/* ********** */}
          <div className="contenedor-cards-arrows relative">
            <div className="atributos-productos scroll-none relative z-10 hidden h-[75px] items-center justify-center gap-2 overflow-y-hidden overflow-x-scroll px-4 lg:flex lg:h-[150px] lg:justify-between lg:gap-6 lg:overflow-x-hidden lg:px-0">
              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                 {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.motor}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.vatios}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoBrushless}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.bateria}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.ampere}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipo}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.distancia}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.km}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoAutonomia}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.velocidadNum}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kmh}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.velocidadMaxima}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.peso}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kg}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pesoMaximo}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.frenos}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.frenosNulo}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipofrenos}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pulgadas}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoRodamiento}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.llanta}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pesoSc}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kgPesoScooter}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tpeso}
                </p>
              </div>
            </div>

            {/* ******************* */}

            <div className="carusel-movil mt-4 flex h-full gap-1 overflow-y-hidden overflow-x-scroll p-[5px] lg:hidden b">
              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.motor}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.vatios}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoBrushless}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.bateria}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.ampere}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipo}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                 {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.distancia}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.km}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoAutonomia}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.velocidadNum}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kmh}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.velocidadMaxima}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.peso}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kg}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pesoMaximo}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.frenos}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.frenosNulo}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipofrenos}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pulgadas}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tipoRodamiento}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.llanta}
                </p>
              </div>

              <div className="cards flex h-[65px]  w-[72px] flex-none flex-col items-center justify-between rounded-[6px] bg-[#F0EEED] py-[10px] lg:h-[116px] lg:w-[130px] lg:justify-evenly  2xl:h-[150px] 2xl:w-[200px]">
                <p
                  className={`${manrope.className}  text-center text-[12px] font-bold lg:text-[25px] 2xl:text-[35px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.pesoSc}
                </p>
                <p
                  className={`${manrope.className}  text-center text-[10px] font-bold lg:text-[16px] 2xl:text-[22px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.kgPesoScooter}
                </p>
                <p
                  className={`${ubuntu.className}  text-center text-[7px] font-normal lg:text-[12px] 2xl:text-[18px]`}
                >
                  {mincaCity.sliderEbikes.edges[0].node.sliderProductosEbikes.tpeso}
                </p>
              </div>
            </div>
            {/* <div className="scroll-indicator m-auto"></div> */}

            <div className="block lg:hidden mb-[70px]">
                <Link
                href={`/productos/Mopeds_Electricas/MOPED_ELCTRICA_MINCA_CITY_350W`}
                className="btn-scooter lg: relative z-10 lg:top-[60%] lg:flex"
              >
                <button
                  type="button"
                  className={`${ubuntu.className} bg-[#111] text-white  my-3 h-[52px] w-full rounded-[62px] text-[16px]  lg:w-[210px]`}
                >
                  Compra Ahora
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
